import * as Cesium from 'cesium';

export class PolygonDrawingHelper {
  private viewer: Cesium.Viewer;
  private positions: Cesium.Cartesian3[] = [];
  private pointEntities: Cesium.Entity[] = [];
  private polygonEntity: Cesium.Entity | null = null;
  private handler: Cesium.ScreenSpaceEventHandler | null = null;

  constructor(viewer: Cesium.Viewer) {
    this.viewer = viewer;
  }

  startDrawing() {
    this.clear();
    this.positions = [];
    this.pointEntities = [];
    this.polygonEntity = null;

    if (this.handler) {
      this.handler.destroy();
      this.handler = null;
    }
    this.handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);

    // Add point on left click
    this.handler.setInputAction((event: any) => {
      const position = this.viewer.camera.pickEllipsoid(event.position, this.viewer.scene.globe.ellipsoid);
      if (position) {
        this.positions.push(position);

        // Add white point marker
        const pointEntity = this.viewer.entities.add({
          position,
          point: {
            pixelSize: 10,
            color: Cesium.Color.WHITE,
            outlineColor: Cesium.Color.BLACK,
            outlineWidth: 2,
            disableDepthTestDistance: Number.POSITIVE_INFINITY
          }
        });
        this.pointEntities.push(pointEntity);

        // Draw or update polygon
        this.updatePolygon();
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

    // Finish on double click
    this.handler.setInputAction(() => {
      if (this.positions.length >= 3) {
        this.finishDrawing();
      }
    }, Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
  }

  private updatePolygon() {
    if (this.positions.length < 2) return;

    if (!this.polygonEntity) {
      this.polygonEntity = this.viewer.entities.add({
        polygon: {
          hierarchy: new Cesium.CallbackProperty(() => {
            return new Cesium.PolygonHierarchy(this.positions);
          }, false),
          material: Cesium.Color.YELLOW.withAlpha(0.5),
          outline: true,
          outlineColor: Cesium.Color.WHITE,
          outlineWidth: 2,
          height: 0
        }
      });
    }
    // No need to update manually, CallbackProperty handles it
  }

  finishDrawing() {
    if (this.handler) {
      this.handler.destroy();
      this.handler = null;
    }
    // Optionally: lock the polygon and points, or leave as is
  }

  clear() {
    if (this.handler) {
      this.handler.destroy();
      this.handler = null;
    }
    if (this.polygonEntity) {
      this.viewer.entities.remove(this.polygonEntity);
      this.polygonEntity = null;
    }
    this.pointEntities.forEach(e => this.viewer.entities.remove(e));
    this.pointEntities = [];
    this.positions = [];
  }

  getPositions(): Cesium.Cartesian3[] {
    return this.positions;
  }
}